import image from '@/assets/img/CycleAi.svg'
import linkedin from '@/assets/img/linkedin-icon.svg'
import facebookicon from '@/assets/img/facebook_icon.svg'
import instagramicon from '@/assets/img/instagram_icon.svg'
import twittericon from '@/assets/img/twitter_icon.svg'
import fundingimage from '@/assets/img/fundingimage.svg'
import "leaflet/dist/leaflet.css";
import geojson from "@/assets/Limites_Cartografia.json"
import { LMap, LTileLayer, LTooltip, LMarker, LIcon, LPopup, LCircle } from 'vue2-leaflet';
import { InfoControl, ReferenceChart, ChoroplethLayer } from 'vue-choropleth'
import LPrintControl from 'leaflet-easyprint';
import LControlFullscreen from 'vue2-leaflet-fullscreen';
import pin from "@/assets/img/place_black_hotspot_marker.svg";
import Cycle25 from '@/assets/img/cycleAI-25.svg'
import Cycle50 from '@/assets/img/cycleAI-50.svg'
import Cycle75 from '@/assets/img/cycleAI-75.svg'
import Cycle90 from '@/assets/img/cycleAI-90.svg'
import CycleFull from '@/assets/img/cycleAI-full.svg'
import CyclePlain from '@/assets/img/cycleAI-plain.svg'
import constants from '@/resources/constants'
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  data: () => ({
    url: 'https://api.mapbox.com/styles/v1/warcraft12321/cllkp93wl019c01pi9t8762qg/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoid2FyY3JhZnQxMjMyMSIsImEiOiJja3Q3anJ3ejQwbWdlMnVwY25rOTdlNWtvIn0.jFuDsRpgQi3bNODw6EmuGQ',
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    center: [38.736946, -9.142685],
    colorScale: ["f3c499", "e26d00"],
    value: {
      key: "safety_score",
      metric: "",
    },
    mapOptions: {
      attributionControl: false,
      zoomControl: true,
      zoomDelta: 0.25,
      zoomSnap: 0
    },
    zoom: 12,
    geojson: geojson,
    image,
    facebookicon,
    linkedin,
    instagramicon,
    twittericon,
    fundingimage,
    pin,
    Cycle25,
    Cycle50,
    Cycle75,
    Cycle90,
    CycleFull,
    CyclePlain,
    tab: null,
    selectedCountry: 'All',
    selectedCity: 'All',
    loading: true,
    averageScore: 0,
    safetyStandDev: 0,
    bikeableCityCount: 0,
    totalUpVotes: 0,
    totalDownVotes: 0,
    totalVotesNo: 0,
    avgVotesNo: 0,
    avgUpVotes: 0,
    avgDownVotes: 0,
    hotspotCountryCount: 0,
    totalBicycles: 0,
    totalDocs: 0,
    avgBicycles: 0,
    avgDocs: 0,
    avgRacio: 0,
    showSafetyDetail: false,
    showHotspotDetail: false,
    showBicycleDetail: false,
    showNeighborDetail: false,
    showCycleFactorDetail: false,
    totalSafetyScore: 0,
    totalStandardDev: 0,
    totalNoPoints: 0,
    avgNoPoints: 0,
    avgSafetyScore: 0,
    avgStandardDev: 0,
    allCountries: [
      { text: 'All Countries', value: 'All'},
    ],
    allCities: [
      { text: 'All Cities', value: 'All'},
    ],
    headers: [
      { text: '#', sortable: false},
      { text: 'Latitude', value: 'lat'},
      { text: 'Longitude', value: 'lon' },
      { text: 'Safety Score', value: 'safety' },
      { text: 'City', value: 'city', sortable: 'false' },
      { text: 'Location', sortable: false},
    ],
    bikeableData: [],
    hotspotHeader: [
      { text: '#', sortable: false},
      { text: 'Latitude', value: 'latitude'},
      { text: 'Longitude', value: 'longitude' },
      { text: 'Votes Number', value: 'no_votes' },
      { text: 'Country', sortable: false, value: 'country'},
      { text: 'City', sortable: false, value: 'city'},
      { text: 'Address', sortable: false, value: 'name'},
      { text: 'Solved', sortable: false},
      { text: 'Up Votes', value: 'up_votes'},
      { text: 'Down Votes', value: 'down_votes'},
      { text: 'Description', value: 'description', sortable: false},
    ],
    hotspotData: [],
    bicycleHeader: [
      { text: '#', sortable: false },
      { text: 'Latitude', value: 'properties.bbox[0]' },
      { text: 'Longitude', value: 'properties.bbox[1]' },
      { text: 'Location', sortable: false, value: 'properties.desig_comercial' },
      { text: 'No. Bicycles', value: 'properties.num_bicicletas' },
      { text: 'No. Docs', value: 'properties.num_docas' },
      { text: 'Date', sortable: false, value: 'properties.update_date' },
      { text: 'State', sortable: false, value: 'properties.estado' },
      { text: 'Service Type', sortable: false, value: 'properties.tipo_servico_niveis' },
      { text: 'Ratio', value: 'properties.racio' },
    ],
    bicycleData: [],
    neighborHeader: [
      { text: '#', sortable: false },
      { text: 'Name', sortable: false, value: 'name' },
      { text: 'Safety Score', value: 'safety_score' },
      { text: 'Standard Deviation', value: 'std_dev' },
      { text: 'No. Points', value: 'num_points' },
      { text: 'Country', sortable: false, value: 'country' },
      { text: 'City', sortable: false, value: 'city' }
    ],
    neighborData: [],
    cyclingRiskHeader: [
      { text: '#', sortable: false },
      { text: 'Id', sortable: false, value: 'id' },
      { text: 'Latitude', value: 'latitude' },
      { text: 'Longitude', value: 'longitude' },
      { text: 'Total', value: 'total' },
      { text: 'Location', sortable: false },
      { text: 'Banner', sortable: false, value: 'banner' },
      { text: 'Barrier', sortable: false, value: 'barrier'},
      { text: 'Bench', sortable: false, value:'bench' },
      { text: 'Bicycle', sortable: false, value:'bicycle' },
      { text: 'Bicyclist', sortable: false, value:'bicyclist' },
      { text: 'Bike Lane', sortable: false, value:'bike_lane' },
      { text: 'Bike Rack', sortable: false, value:'bike_rack' },
      { text: 'Billboard', sortable: false, value:'billboard' },
      { text: 'Bird', sortable: false, value:'bird' },
      { text: 'Boat', sortable: false, value:'boat' },
      { text: 'Bridge', sortable: false, value:'bridge' },
      { text: 'Building', sortable: false, value:'building' },
      { text: 'Bus', sortable: false, value:'bus' },
      { text: 'Car', sortable: false, value:'car' },
      { text: 'Car Mount', sortable: false, value:'car_mount' },
      { text: 'Caravan', sortable: false, value:'caravan' },
      { text: 'Catch Basin', sortable: false, value:'catch_basin' },
      { text: 'Cctv Camera', sortable: false, value:'cctv_camera' },
      { text: 'Crosswalk Plain', sortable: false, value:'crosswalk_plain' },
      { text: 'Curb', sortable: false, value:'curb' },
      { text: 'Curb Cut', sortable: false, value:'curb_cut' },
      { text: 'Ego Vehicle', sortable: false, value:'ego_vehicle' },
      { text: 'Fence', sortable: false, value:'fence' },
      { text: 'Fire_hydrant', sortable: false, value:'fire_hydrant' },
      { text: 'Ground Animal', sortable: false, value:'ground_animal' },
      { text: 'Guard Rail', sortable: false, value:'guard_rail' },
      { text: 'Junction Box', sortable: false, value:'junction_box' },
      { text: 'Lane Marking Crosswalk', sortable: false, value:'lane_marking_crosswalk' },
      { text: 'Lane Marking General', sortable: false, value:'lane_marking_general' },
      { text: 'Mailbox', sortable: false, value:'mailbox' },
      { text: 'Manhole', sortable: false, value:'manhole' },
      { text: 'Motorcycle', sortable: false, value:'motorcycle' },
      { text: 'Motorcyclist', sortable: false, value:'motorcyclist' },
      { text: 'Mountain', sortable: false, value:'mountain' },
      { text: 'On Rails', sortable: false, value:'on_rails' },
      { text: 'Other Rider', sortable: false, value:'other_rider' },
      { text: 'Other Vehicle', sortable: false, value:'other_vehicle' },
      { text: 'Parking', sortable: false, value:'parking' },
      { text: 'Pedestrian Area', sortable: false, value:'pedestrian_area' },
      { text: 'Person', sortable: false, value:'person' },
      { text: 'Phone Booth', sortable: false, value:'phone_booth' },
      { text: 'Pole', sortable: false, value:'pole' },
      { text: 'Pothole', sortable: false, value:'pothole' },
      { text: 'Rail Track', sortable: false, value:'rail_track' },
      { text: 'Road', sortable: false, value:'road' },
      { text: 'Sand', sortable: false, value:'sand' },
      { text: 'Service Lane', sortable: false, value:'service_lane' },
      { text: 'Sidewalk', sortable: false, value:'sidewalk' },
      { text: 'Sky', sortable: false, value:'sky' },
      { text: 'Snow', sortable: false, value:'snow' },
      { text: 'Street Light', sortable: false, value:'street_light' },
      { text: 'Terrain', sortable: false, value:'terrain' },
      { text: 'Traffic Light', sortable: false, value:'traffic_light' },
      { text: 'Traffic Sign Back', sortable: false, value:'traffic_sign_back' },
      { text: 'Traffic Sign Frame', sortable: false, value:'traffic_sign_frame' },
      { text: 'Traffic Sign Front', sortable: false, value:'traffic_sign_front' },
      { text: 'Trailer', sortable: false, value:'trailer' },
      { text: 'Trash Can', sortable: false, value:'trash_can' },
      { text: 'Truck', sortable: false, value:'truck' },
      { text: 'Tunnel', sortable: false, value:'tunnel' },
      { text: 'Unlabeled', sortable: false, value:'unlabeled' },
      { text: 'Utility Pole', sortable: false, value:'utility_pole' },
      { text: 'Vegetation', sortable: false, value:'vegetation' },
      { text: 'Wall', sortable: false, value:'wall' },
      { text: 'Water', sortable: false, value:'water' },
      { text: 'Wheeled Slow', sortable: false, value:'wheeled_slow' },
    ],
    cyclingRiskData: [],
    selectedFeature: { text: 'Total', value: 'total'},
    cycleTotal: 0,
    avgCycleTotal: 0,
    dayView: false,
    circleColor: {
      1.0: "#FA1443",
      1.1: "#FB1A46",
      1.2: "#F81A43",
      1.3: "#F92043",
      1.4: "#F92442",
      1.5: "#F62940",
      1.6: "#F62B3F",
      1.7: "#FB3044",
      1.8: "#F83441",
      1.9: "#F8363E",
      2.0: "#F83A3C",
      2.1: "#F73E39",
      2.2: "#F84237",
      2.3: "#F84738",
      2.4: "#F64934",
      2.5: "#F74C32",
      2.6: "#F65230",
      2.7: "#F6542F",
      2.8: "#F5582D",
      2.9: "#F45D28",
      3.0: "#F66128",
      3.1: "#F66627",
      3.2: "#F56725",
      3.3: "#F66E22",
      3.4: "#F77424",
      3.5: "#F4761F",
      3.6: "#F67B1E",
      3.7: "#F6801C",
      3.8: "#F48418",
      3.9: "#F38718",
      4.0: "#F68E15",
      4.1: "#F49110",
      4.2: "#F79611",
      4.3: "#F59A0D",
      4.4: "#F49E0D",
      4.5: "#F5A009",
      4.6: "#F3A303",
      4.7: "#F5A603",
      4.8: "#F6A903",
      4.9: "#F4AA01",
      5.0: "#F1A900",
      5.0: "#F1A900",
      5.1: "#ECAA01",
      5.2: "#E8AA01",
      5.3: "#E4A900",
      5.4: "#E1AA01",
      5.5: "#DDAA01",
      5.6: "#DAAB01",
      5.7: "#D5AA00",
      5.8: "#D2AA01",
      5.9: "#CFAB01",
      6.0: "#CBAB01",
      6.1: "#C7AC01",
      6.2: "#C4AC01",
      6.3: "#C0AC01",
      6.4: "#BCAC01",
      6.5: "#B9AD01",
      6.6: "#B5AD01",
      6.7: "#B0AC00",
      6.8: "#ADAD01",
      6.9: "#A9AC00",
      7.0: "#A6AD01",
      7.1: "#A2AD00",
      7.2: "#9EAD00",
      7.3: "#9BAE01",
      7.4: "#98AE01",
      7.5: "#94AE01",
      7.6: "#90AF01",
      7.7: "#8CAF01",
      7.8: "#88AE00",
      7.9: "#85AF01",
      8.0: "#81AF00",
      8.1: "#7EB001",
      8.2: "#7AB001",
      8.3: "#77B001",
      8.4: "#72AF00",
      8.5: "#6FB001",
      8.6: "#6BB101",
      8.7: "#68B101",
      8.8: "#64B101",
      8.9: "#60B101",
      9.0: "#5DB101",
      9.1: "#59B201",
      9.2: "#55B201",
      9.3: "#52B201",
      9.4: "#4EB201",
      9.5: "#4BB201",
      9.6: "#47B301",
      9.7: "#43B301",
      9.8: "#3FB301",
      9.9: "#3CB301",
      10.0: "#38B301",
    },
    bikeableMarkers: [],
    hotspotMarkers: [],
    bicycleMarkers: [],
    bikeableCircleMarkers: [],
    cycleRiskMarkers: [],
    cycleRiskCircleMarkers: [],
    cycleSums: [],
    cycleAvg: [],
    orderedKeys: [
      'sum_banner','sum_barrier','sum_bench','sum_bicycle','sum_bicyclist','sum_bike_lane','sum_bike_rack','sum_billboard','sum_bird',
      'sum_boat','sum_bridge','sum_building','sum_bus','sum_car','sum_car_mount','sum_caravan','sum_catch_basin','sum_cctv_camera',
      'sum_crosswalk_plain','sum_curb','sum_curb_cut','sum_ego_vehicle','sum_fence','sum_fire_hydrant','sum_ground_animal','sum_guard_rail',
      'sum_junction_box','sum_lane_marking_crosswalk','sum_lane_marking_general','sum_mailbox','sum_manhole','sum_motorcycle','sum_motorcyclist',
      'sum_mountain','sum_on_rails','sum_other_rider','sum_other_vehicle','sum_parking','sum_pedestrian_area','sum_person','sum_phone_booth',
      'sum_pole','sum_pothole','sum_rail_track','sum_road','sum_sand','sum_service_lane','sum_sidewalk','sum_sky','sum_snow','sum_street_light',
      'sum_terrain','sum_traffic_light','sum_traffic_sign_back','sum_traffic_sign_frame','sum_traffic_sign_front','sum_trailer','sum_trash_can',
      'sum_truck','sum_tunnel','sum_unlabeled','sum_utility_pole','sum_vegetation','sum_wall','sum_water','sum_wheeled_slow'
    ],
    startColor: "#38B301",
    endColor: "#FA1443",
    bikeableRange: [1.0, 3.0],
    bikeableRadiusRange: 25,
    cycleRadiusRange: 25,
    minCycle: 0,
    maxCycle: 100,
    multiplier: 1,
    cycleRange: [0, 100],
  }),
  components: {
    LMap,
    LTileLayer,
    LControlFullscreen,
    LMarker,
    LIcon,
    LTooltip,
    LPopup,
    LCircle,
    'l-info-control': InfoControl, 
    'l-reference-chart': ReferenceChart, 
    'l-choropleth-layer': ChoroplethLayer,
    VueSlider
  },
  computed: {
    formatTooltip() {
      return (value) => {
        return this.formatValue(value);
      };
    },
    baseurl() {
      if (constants.staging) {
        return 'https://routeplanner.staging.cycleai.net/'
      } else {
        return 'https://routeplanner.cycleai.net/'
      }
    },
    filteredFeatureOptions() {
      var excludedOptions = ['#', 'Id', 'Latitude', 'Longitude', 'Location']
      return this.cyclingRiskHeader.filter(option => !excludedOptions.includes(option.text));
    },
  },
  created() {
    // Fetching All Countries
    this.getAllCountries()

    // Fetching All Cities
    this.getAllCities()
  },
  mounted() {
    this.getAllData()
    this.addPrintOpt(this.$refs.myBikeableMap.mapObject, 'Bikeable Safety Score', 'myCycleRiskMap');
    this.addPrintOpt(this.$refs.myHotspotMap.mapObject, 'Hotspot Points', 'myHotspotMap');
    this.addPrintOpt(this.$refs.myBicycleMap.mapObject, 'Bicycle Stations', 'myBicycleMap');
    this.addPrintOpt(this.$refs.myNeighborhoodMap.mapObject, 'Neighborhood Safety Score', 'myNeighborhoodMap');
    this.addPrintOpt(this.$refs.myCycleRiskMap.mapObject, 'Cycling Risk Factor', 'myCycleRiskMap');
    // Adding Label to Geojson points
    // var datalayer = L.geoJson(this.geojson, {
    //   style: function (feature) {
    //     return {
    //         weight: 2,
    //         fill: false,
    //         opacity: 1,
    //         clickable: false
    //     };
    //   },
    //   onEachFeature: function(feature, featureLayer) {
    //     featureLayer.bindTooltip(
    //       feature.properties.NOME,
    //       { permanent: true,
    //         direction: "center",
    //         className: "my-labels",
    //         offset: L.point({x: -30, y: -40})
    //       }
    //     ).openTooltip();
    //   },
    // }).addTo(map);

  },
  watch: {
    dayView: function(newVal, oldVal) {
      this.changeMap(newVal);
    },
  },
  methods: {
    getAllCountries() {
      fetch(this.baseurl + 'api/getAllCountriesDataHub/', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        }
      })
        .then(response => response.json())
        .then(data => {
          data.forEach(
            (item) => this.allCountries.push({'text': item.country, 'value':item.country})
          )
        })
    },
    getAllCities(country = null) {
      let url = ''
      let collectedCities = [{ text: 'All Cities', value: 'All'}]
      // this.selectedCity = collectedCities
      if (country && country != 'All') {
        url = 'api/getAllCitiesDataHub?country=' + country
      } else {
        url = 'api/getAllCitiesDataHub'
      }

      fetch(this.baseurl + url, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        }
      })
        .then(response => response.json())
        .then(data => {
          data.forEach(
            (item) => collectedCities.push({'text': item.city, 'value': item.city})
          )
        })
      return collectedCities
    },
    onChangeCountryCity () {
      this.loading = true
      this.analyticsEvent("data_hub_country_change", "country_change", "User changed the country", this.selectedCountry);
      if (this.selectedCountry) {
        this.allCities = this.getAllCities(this.selectedCountry)
      }
      this.selectedCity = 'All'
      var map = this.$refs.myBikeableMap.mapObject;
      this.removeMarkedMarkers(map, 'Bikeable')
      this.getAllData()
    },
    onChangeCity() {
      this.loading = true
      this.analyticsEvent("data_hub_city_change", "city_change", "User changed the city", this.selectedCity);
      this.getAllData()
    },
    getAllData() {
      let city = this.selectedCity
      let country = this.selectedCountry
      let param = ''
      if (country != 'All' || city !='All'){
        param=param+'?'
        if (country != 'All')
          param=param+'country='+country
        if (city !='All' && param.includes('country'))
          param=param+'&city='+city
        else if (city !='All')
          param=param+'city='+city
      }
      if (this.tab == 0) {
        this.analyticsEvent("data_hub_tab_change", "tab_change", "User changed the tab to Bikeable Safety Scores", "data_hub_tab_change");
        setTimeout(() => {
          this.$refs.myBikeableMap.mapObject.invalidateSize(); 
        }, 100);
        fetch(this.baseurl + 'api/getSafetyPoints' + param, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json;charset=UTF-8'
          }
        })
          .then(response => response.json())
          .then(data => {
            this.loading = false
            this.bikeableData = data
            var map = this.$refs.myBikeableMap.mapObject;
            if (this.bikeableData.length > 0) {
              let sum_safety = 0
              let std = []
              let allCities = []
              
              this.bikeableData.forEach(
                (item) =>{
                  item.index = this.bikeableData.indexOf(item)+1
                  item.link = 'https://maps.google.com/maps?q='+item.lat+','+item.lon
                  sum_safety = sum_safety + Number(item.safety)
                  std.push(Number(item.safety))
                  allCities.push(item.city)
                }
              )
              
              this.processBikeableData();
              map.on('zoomend', function() {
                var currentZoom = map.getZoom();
                let pixel = 20;
                if (currentZoom == 18) {
                  pixel = 20;
                } else if (currentZoom == 17) {
                  pixel = 10;
                } else if (currentZoom == 16) {
                  pixel = 4;
                } else if (currentZoom == 15) {
                  pixel = 2;
                } else if (currentZoom == 14) {
                  pixel = 1;
                } else if (currentZoom == 13) {
                  pixel = 1;
                } else {
                  pixel = 0;
                }
                      
                // Check the current zoom level and update map style or layers
                if (currentZoom >= 10) {
                  if (document.getElementsByClassName("circle-custom").length > 0) {
                    let hostport = document.getElementsByClassName("circle-custom")
                      .length;
                    for (let index = 0; index < hostport; index++) {
                      document
                        .getElementsByClassName("circle-custom")
                        [index].setAttribute(
                          "style",
                          "display:block;filter:blur(" + pixel + "px)"
                        );
                    }
                  }
                } 
              });
              const bounds = L.latLngBounds(this.bikeableMarkers)
              map.fitBounds(bounds);
              this.bikeableCityCount = [...new Set(allCities)].length
              this.averageScore = (sum_safety / this.bikeableData.length).toFixed(1) 
              this.safetyStandDev = (this.getStandardDeviation(std)).toFixed(1)
            } else {
              this.averageScore = 0
              this.safetyStandDev = 0
              this.bikeableCityCount = 0
            }
          })
      } else if (this.tab == 1) {
        this.analyticsEvent("data_hub_tab_change", "tab_change", "User changed the tab to Hotspot Points", "data_hub_tab_change");
        setTimeout(() => {
          this.$refs.myHotspotMap.mapObject.invalidateSize(); 
        }, 100);
        fetch(this.baseurl + 'api/getHotspots' + param, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json;charset=UTF-8'
          }
        })
          .then(response => response.json())
          .then(data => {
            this.loading = false
            this.hotspotData = data
            var map = this.$refs.myHotspotMap.mapObject;
            this.removeMarkedMarkers(map)
            this.hotspotMarkers = []
            if (this.hotspotData.length > 0) {
              let sum_up_votes = 0
              let sum_down_votes = 0
              let sum_votes_no = 0
              let allCountry = []
              this.hotspotData.forEach(
                (item) =>{
                  item.index = this.hotspotData.indexOf(item)+1
                  sum_up_votes = sum_up_votes + Number(item.up_votes)
                  sum_down_votes = sum_down_votes + Number(item.down_votes)
                  sum_votes_no = sum_votes_no + Number(item.no_votes)
                  allCountry.push(item.country)
                  this.hotspotMarkers.push([item.latitude, item.longitude])

                  var icon = L.marker([item.latitude,item.longitude], {
                    icon: new L.divIcon({
                      className: 'my-custom-hotspot-icon',
                      html: '<div class="icon-content">' + item.no_votes + '</div>',
                      iconSize: [34, 34],
                      iconAnchor: [17, 34]
                    }),
                  });
                  icon.bindPopup(L.popup().setContent('Up Votes: ' + item.up_votes + '<br />' + 'Down Votes: ' + item.down_votes))
                  icon.addTo(map);
                }
              )
              const bounds = L.latLngBounds(this.hotspotMarkers)
              map.fitBounds(bounds, {
                padding: [10, 10],
              });
              this.hotspotCountryCount = [...new Set(allCountry)].length
              this.totalUpVotes = sum_up_votes
              this.totalDownVotes = sum_down_votes
              this.totalVotesNo = sum_votes_no
              this.avgVotesNo =  (sum_votes_no / this.hotspotData.length).toFixed(2)
              this.avgUpVotes =  (sum_up_votes / this.hotspotData.length).toFixed(2)
              this.avgDownVotes =  (sum_down_votes / this.hotspotData.length).toFixed(2)
            } else {
              this.totalUpVotes = 0
              this.totalDownVotes = 0
              this.totalVotesNo = 0
              this.avgVotesNo = 0
              this.avgUpVotes = 0
              this.avgDownVotes = 0
              this.hotspotCountryCount = 0
            }
          })
      } else if(this.tab == 2) {
        this.analyticsEvent("data_hub_tab_change", "tab_change", "User changed the tab to Bicycle Stations", "data_hub_tab_change");
        setTimeout(() => {
          this.$refs.myBicycleMap.mapObject.invalidateSize(); 
        }, 100);
        fetch(this.baseurl + 'api/getBicycleStations'+ param, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json;charset=UTF-8'
          }
        })
          .then(response => response.json())
          .then(data => {
            this.loading = false
            this.bicycleMarkers = []
            var map = this.$refs.myBicycleMap.mapObject;
            this.removeMarkedMarkers(map)
            if (data.length != 0) {
              this.bicycleData = data.features
              if (this.bicycleData && this.bicycleData.length > 0) {
                let sum_num_bicicletas = 0
                let sum_num_docas = 0
                let sum_racio = 0
                this.bicycleData.forEach(
                  (item) => {
                    item.index = this.bicycleData.indexOf(item)+1
                    sum_num_bicicletas = sum_num_bicicletas + Number(item.properties.num_bicicletas)
                    sum_num_docas = sum_num_docas + Number(item.properties.num_docas)
                    sum_racio = sum_racio + Number(item.properties.racio)
                    this.bicycleMarkers.push([item.properties.bbox[1],item.properties.bbox[0]])
                    
                    let iconUrl
                    let imagePR = item.properties.num_bicicletas === 0 ? 0 : (( item.properties.num_bicicletas/item.properties.num_docas) * 100).toFixed(0) 
                    if(imagePR === 0) {
                      iconUrl = CyclePlain
                    } else if(imagePR <= 25) {
                      iconUrl = Cycle25
                    } else if(imagePR <= 50) {
                      iconUrl = Cycle50
                    } else if(imagePR <= 75) {
                      iconUrl = Cycle75
                    } else if(imagePR <= 99) {
                      iconUrl = Cycle90
                    } else if(imagePR <= 100) {
                      iconUrl = CycleFull
                    }
                    var icon = L.marker([item.properties.bbox[1],item.properties.bbox[0]], {
                      icon: new L.Icon({
                        iconUrl: iconUrl,
                        iconSize: [34, 34],
                        iconAnchor: [17, 34]
                      }),
                    });
                    icon.bindPopup(L.popup().setContent((item.properties.num_bicicletas === 0 ? '0/' + item.properties.num_docas : item.properties.num_bicicletas + '/' + item.properties.num_docas) + ' bicycles'))
                    icon.addTo(map);
                  }
                )
                const bounds = L.latLngBounds(this.bicycleMarkers)
                map.fitBounds(bounds, {
                  padding: [10, 10],
                });
                this.totalBicycles = sum_num_bicicletas
                this.totalDocs = sum_num_docas
                this.avgBicycles = (sum_num_bicicletas / this.bicycleData.length).toFixed(2)
                this.avgDocs = (sum_num_docas / this.bicycleData.length).toFixed(2)
                this.avgRacio = (sum_racio / this.bicycleData.length).toFixed(2)
              } else {
                this.totalBicycles = 0
                this.totalDocs = 0
                this.avgBicycles = 0
                this.avgDocs = 0
                this.avgRacio = 0
              }
            } else {
              this.bicycleData = data
              this.totalBicycles = 0
              this.totalDocs = 0
              this.avgBicycles = 0
              this.avgDocs = 0
              this.avgRacio = 0
            }
          })
      } else if(this.tab == 3) {
        this.analyticsEvent("data_hub_tab_change", "tab_change", "User changed the tab to Neighborhood Safety Scores", "data_hub_tab_change");
        setTimeout(() => {
          this.$refs.myNeighborhoodMap.mapObject.invalidateSize(); 
        }, 100);
        fetch(this.baseurl + 'api/getNeighborhoods' + param, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json;charset=UTF-8'
          }
        })
          .then(response => response.json())
          .then(data => {
            this.loading = false
            this.neighborData = data

            if (this.neighborData.length > 0) {
              let sum_safety_score = 0
              let sum_std_dev = 0
              let sum_num_points = 0
              this.neighborData.forEach(
                (item) =>{
                  item.index = this.neighborData.indexOf(item)+1
                  item.safety_score = (item.safety_score).toFixed(1)
                  item.std_dev = (item.std_dev).toFixed(1)
                  sum_safety_score = sum_safety_score + Number(item.safety_score)
                  sum_std_dev = sum_std_dev + Number(item.std_dev)
                  sum_num_points = sum_num_points + Number(item.num_points)
                }
              )
              this.totalNoPoints = sum_num_points
              this.avgSafetyScore = (sum_safety_score / this.neighborData.length).toFixed(1)
              this.avgStandardDev = (sum_std_dev / this.neighborData.length).toFixed(1)
              this.avgNoPoints = (sum_num_points / this.neighborData.length).toFixed(0)
            } else {
              this.totalNoPoints = 0
              this.avgSafetyScore = 0
              this.avgStandardDev = 0
              this.avgNoPoints = 0
            }
          })
      } else if(this.tab == 4) {
        this.analyticsEvent("data_hub_tab_change", "tab_change", "User changed the tab to Cycling Risk Factors", "data_hub_tab_change");
        setTimeout(() => {
          this.$refs.myCycleRiskMap.mapObject.invalidateSize(); 
        }, 100);
        fetch(this.baseurl + 'api/getRiskFactorsImgSegm' + param, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json;charset=UTF-8'
          }
        })
          .then(response => response.json())
          .then(data => {
            setTimeout(() => {
              this.loading = false 
            }, 5000);
            this.cyclingRiskData = data
            var max = Math.max(...this.cyclingRiskData.map(item => item[this.selectedFeature.value]));
            var min = Math.min(...this.cyclingRiskData.map(item => item[this.selectedFeature.value])); 
            var range = this.convertToIntegers(min, max)

            this.maxCycle = range['maxValue'] 
            this.minCycle = range['minValue']
            this.multiplier = range['multiplier']
            this.cycleRange = [this.minCycle, this.maxCycle]
            let sum_total = 0
            let excludedFields = [ 'id', 'latitude', 'longitude', 'total', 'link', 'index']
            var map = this.$refs.myCycleRiskMap.mapObject;
            if (this.cyclingRiskData.length > 0) {
              this.cyclingRiskData.forEach(
                (item) =>{
                  item.index = this.cyclingRiskData.indexOf(item)+1
                  item.link = 'https://maps.google.com/maps?q='+item.latitude+','+item.longitude
                  sum_total = sum_total+Number(item.total)
                  let fieldCount = 0
                  Object.keys(item).forEach((field) => {
                    fieldCount += 1
                    if (!excludedFields.includes(field)) {
                      const sumKey = `sum_${field}`;
                      if (!this.cycleSums.hasOwnProperty(sumKey)) {
                        this.cycleSums[sumKey] = 0;
                      }
                      this.cycleSums[sumKey] += Number(item[field]);
                    }
                  })
                }
              )
              this.cycleTotal = (sum_total).toFixed(2)
              map.on('zoomend', function() {
                var currentZoom = map.getZoom();
                let pixel = 20;
                if (currentZoom == 18) {
                  pixel = 20;
                } else if (currentZoom == 17) {
                  pixel = 10;
                } else if (currentZoom == 16) {
                  pixel = 4;
                } else if (currentZoom == 15) {
                  pixel = 2;
                } else if (currentZoom == 14) {
                  pixel = 1;
                } else if (currentZoom == 13) {
                  pixel = 1;
                } else {
                  pixel = 0;
                }
                      
                // Check the current zoom level and update map style or layers
                if (currentZoom >= 10) {
                  if (document.getElementsByClassName("circle-custom").length > 0) {
                    let hostport = document.getElementsByClassName("circle-custom")
                      .length;
                    for (let index = 0; index < hostport; index++) {
                      document
                        .getElementsByClassName("circle-custom")
                        [index].setAttribute(
                          "style",
                          "display:block;filter:blur(" + pixel + "px)"
                        );
                    }
                  }
                } 
              });
              
              this.processCycleData()
              
              Object.keys(this.cycleSums).forEach((field) => {
                if (!this.cycleAvg.hasOwnProperty(field)) {
                  this.cycleAvg[field] = 0;
                }
                this.cycleAvg[field] = (this.cycleSums[field] / this.cyclingRiskData.length).toFixed(2)
              })
              this.avgCycleTotal = (sum_total / this.cyclingRiskData.length).toFixed(2)
            } else {
              
            }
          })
      }
    },
    download(tab) {
      let text = ''
      let filename = ''
      if (tab == 0) {
        this.analyticsEvent("data_hub_dwnld_data", "download_data", "User downloaded data of Bikeable Safety Scores", "data_hub_dwnld_data");
        text = JSON.stringify(this.bikeableData)
        filename = 'saftey_points.json'
      } else if (tab == 1) {
        this.analyticsEvent("data_hub_dwnld_data", "download_data", "User downloaded data of Hotspot Points", "data_hub_dwnld_data");
        text = JSON.stringify(this.hotspotData)
        filename = 'hotspot_points.json'
      } else if (tab == 2) {
        this.analyticsEvent("data_hub_dwnld_data", "download_data", "User downloaded data of Bicycle Stations", "data_hub_dwnld_data");
        text = JSON.stringify(this.bicycleData)
        filename = 'bicycle_stations.json'
      } else if (tab == 3) {
        this.analyticsEvent("data_hub_dwnld_data", "download_data", "User downloaded data of Neighborhood Safety Scores", "data_hub_dwnld_data");
        text = JSON.stringify(this.neighborData)
        filename = 'neighborhood_scores.json'
      } else if (tab == 4) {
        this.analyticsEvent("data_hub_dwnld_data", "download_data", "User downloaded data of Cycling Risk Factor", "data_hub_dwnld_data");
        text = JSON.stringify(this.neighborData)
        filename = 'cycling_risk_factor.json'
      } 
      let element = document.createElement('a')
      element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(text))
      element.setAttribute('download', filename)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()
      document.body.removeChild(element)
    },
    getStandardDeviation (scoreArr) {
      const n = scoreArr.length
      const mean = scoreArr.reduce((a, b) => a + b, 0) / n
      return Math.sqrt(scoreArr.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n)
    },
    changeMap(event) {
      if (event === true) {
        this.url = 'https://api.mapbox.com/styles/v1/warcraft12321/cllksm44y01bz01p8bbldfw7g/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoid2FyY3JhZnQxMjMyMSIsImEiOiJja3Q3anJ3ejQwbWdlMnVwY25rOTdlNWtvIn0.jFuDsRpgQi3bNODw6EmuGQ'
      } else {
        this.url = 'https://api.mapbox.com/styles/v1/warcraft12321/cllkp93wl019c01pi9t8762qg/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoid2FyY3JhZnQxMjMyMSIsImEiOiJja3Q3anJ3ejQwbWdlMnVwY25rOTdlNWtvIn0.jFuDsRpgQi3bNODw6EmuGQ'
      }
    },
    handleFullScreen(map) {
      var mapName;
      if (map == 'myHotspotMap') {
        mapName = this.hotspotMarkers;
      } else if (map == 'myBikeableMap') {
        mapName = this.bikeableMarkers;
      } else if (map == 'myBicycleMap') {
        mapName = this.bicycleMarkers;
      } else if (map == 'myCycleRiskMap') {
        mapName = this.cycleRiskMarkers;
      }
      const bounds = L.latLngBounds(mapName)
      if (this.$refs[map].mapObject.isFullscreen()) {
        this.zoom = 13
        this.$refs[map].mapObject.fitBounds(bounds, {
          padding: [10, 10],
        });
      } else {
        this.zoom = 12
        // this.$refs[map].mapObject.fitBounds(bounds, {
        //   padding: [10, 10],
        // });
      }
    },
    addPrintOpt(map, name, mapContainer) {
      // Map Image Download Plugin
      var size = map.getSize()
      var a3Size = {
        width: 1250,
	      height: 500,
        className: 'a3CssClass',
        tooltip: 'A custom A3 size'
      }
      const printPlugin = L.easyPrint({
        exportOnly: true,
        hidden: true,
        position: 'topleft',
        hideControlContainer: true,
        hideClasses: ['leaflet-control-zoom', 'leaflet-control-fullscreen'],
        sizeModes: ['Current', 'A4Portrait', a3Size],
      }).addTo(map);

      const self = this;
      L.Control.Button = L.Control.extend({
        options: {
          position: 'topleft'
        },
        onAdd: function (map) {
          var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
          var button = L.DomUtil.create('a', 'leaflet-control-button custom-download-button', container);
          L.DomEvent.disableClickPropagation(button);
          L.DomEvent.on(button, 'click', function(){
            self.analyticsEvent("data_hub_dwnld_map", "download_map", "User downloaded" +name + " Map", "data_hub_dwnld_map");
            printPlugin.options.sizeModes[2].height = self.mapSize(map, 'height')
            printPlugin.options.sizeModes[2].width = self.mapSize(map,'width')   
            const zoomControl = self.$refs[mapContainer].$el.querySelectorAll(".leaflet-control-zoom, .leaflet-control, .leaflet-control-fullscreen");
            console.log(zoomControl)
            if (zoomControl) {
              zoomControl.forEach((element) => {
                element.style.display = "none";
              });
            }
            printPlugin.printMap('a3CssClass', name+ " Map");
            map.on('easyPrint-finished', function (ev) {
              zoomControl.forEach((element) => {
                element.style.display = "block";
              });
            });
          });
          button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Interface / Download"> <path id="Vector" d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>';
          container.title = "Download Map";

          return container;
        },
        onRemove: function(map) {},
      });
      var control = new L.Control.Button()
      control.addTo(map);
    },
    analyticsEvent(event, category, label, value){
     return this.$gtag.event(event, {
        event_category: category,
        event_label: label,
        value: value
      });
    },
    removeMarkedMarkers(map, markers, name) {
      if (name == 'Bikeable' || name == 'CycleRisk') {
        markers.forEach(marker => {
          map.removeLayer(marker);
        });
      } else {
        const markerPane = map.getPane('markerPane'); // Get the marker pane
        while (markerPane.firstChild) {
          markerPane.removeChild(markerPane.firstChild);
        }
      }
    },
    mapSize(map, value) {
      var size = map.getSize()
      if (value == 'height'){
        return size.y
      } else {
        return size.x
      }
    },
    onChangeFeature(selectedValue) {
      this.loading = true
      this.analyticsEvent("data_hub_feature_change", "feature_change", "User changed the Feature to view in Cycling Risk Factor Map", this.selectedFeature);
      const selectedOption = this.cyclingRiskHeader.find(option => option.value === selectedValue);
      if (selectedOption) {
        this.selectedFeature = { text: selectedOption.text, value: selectedOption.value };
      }
      var max = Math.max(...this.cyclingRiskData.map(item => item[this.selectedFeature.value]));
      var min = Math.min(...this.cyclingRiskData.map(item => item[this.selectedFeature.value])); 
      var range = this.convertToIntegers(min, max)

      this.maxCycle = range['maxValue'] 
      this.minCycle = range['minValue']
      this.multiplier = range['multiplier']
      this.cycleRange = [this.minCycle, this.maxCycle]
      this.processCycleData()
    },
    processCycleData() {
      this.loading = false
      var map = this.$refs.myCycleRiskMap.mapObject;
      this.removeMarkedMarkers(map, this.cycleRiskCircleMarkers, 'CycleRisk')
      if (this.cyclingRiskData.length > 0) {
        this.cyclingRiskData.forEach(
          (item) =>{
            let fieldCount = 0
            if (this.selectedFeature.text == 'Total') {
              Object.keys(item).forEach((field) => {
                fieldCount += 1
                if (field !== 'index' && field !== 'link') {
                  if (fieldCount < 25) {
                    if (item.content1) {
                      item.content1 += field +':' + item[field] + '<br>'
                    } else {
                      item.content1 = field +':' + item[field] + '<br>'
                    }
                  } else if(fieldCount > 25 && fieldCount < 50) {
                    if (item.content2) {
                      item.content2 += field +':' + item[field] + '<br>'
                    } else {
                      item.content2 = field +':' + item[field] + '<br>'
                    }
                  } else if(fieldCount > 50 && fieldCount < 75) {
                    if (item.content3) {                    
                      item.content3 += field +':' + item[field] + '<br>'
                    } else {
                      item.content3 = field +':' + item[field] + '<br>'
                    }
                  }
                }
              })
              item.content3 += 'Location : ' + '<a target="_blank" href='+item.link+'>Google Maps</a><br>'
            }
            this.cycleRiskMarkers.push([item.latitude, item.longitude])
            var cycleRangeMin = this.cycleRange[0] / this.multiplier;
            var cycleRangeMax = this.cycleRange[1] / this.multiplier;
            if(item[this.selectedFeature.value] != '0'){
              if (item[this.selectedFeature.value] >= cycleRangeMin && item[this.selectedFeature.value] <= cycleRangeMax){ 
                var alphaValue = item[this.selectedFeature.value] * 10;
                var colorString = `rgba(226, 109, 0, ${alphaValue})`;
                var circle = L.circle([item.latitude, item.longitude], {
                  className: 'circle-custom',
                  fillRule: 'evenodd', 
                  fillOpacity: alphaValue,
                  radius: this.cycleRadiusRange,
                  stroke: false,
                  color: colorString,
                });
                if (this.selectedFeature.text == 'Total') { 
                  const popupContent = document.createElement('div');
                  const tableHTML = `
                    <table>
                      <tbody>
                        <tr>
                          <td>` + item.content1 + `</td>
                          <td>` + item.content2 + `</td>
                          <td>` + item.content3 + `</td>
                        </tr>
                      </tbody>
                    </table>
                  `;
                  popupContent.innerHTML = tableHTML;
                  circle.bindPopup(L.popup().setContent(popupContent), {maxWidth: "500", maxHeight: '400', autoPan: 'false', autoPanPadding: L.point({x: 15, y: 15})})  
                } else {
                  var content = this.selectedFeature.text + ' : ' + item[this.selectedFeature.value] + '<br>' + 'Location : ' + '<a target="_blank" href='+item.link+'>Google Maps</a>' 
                  circle.bindPopup(L.popup().setContent(content))
                }
                circle.addTo(map);
                this.cycleRiskCircleMarkers.push(circle);
              }
            }
          }
        )
      }
      const bounds = L.latLngBounds(this.cycleRiskMarkers)
      map.fitBounds(bounds);
    },
    processBikeableData() {
      this.loading = false;
      this.bikeableMarkers = []
      var map = this.$refs.myBikeableMap.mapObject;
      this.removeMarkedMarkers(map, this.bikeableCircleMarkers, 'Bikeable')
      this.bikeableData.forEach(
        (item) =>{
          if (item.safety >= this.bikeableRange[0] && item.safety <= this.bikeableRange[1]) {
            this.bikeableMarkers.push([item.lat, item.lon])
          
            var circle = L.circle([item.lat,item.lon], {
              className: 'circle-custom',
              fillRule: 'evenodd', 
              fillOpacity: 0.8,
              radius: this.bikeableRadiusRange,
              stroke: false,
              color: this.circleColor[Number(item.safety)],
            });
            circle.bindPopup(L.popup().setContent('Safety Score: ' + item.safety + '<br>Location : ' + '<a target="_blank" href='+item.link+'>Google Maps</a>'))
            circle.addTo(map);
            this.bikeableCircleMarkers.push(circle);
          }
        }
      )
    },
    getSumOfColumn(field, item) {
      const sumKey = `sum_${field}`;
      return sumKey + Number(item[field])
    },
    handleBikeableSlider() {
      this.loading = true
      this.analyticsEvent("data_hub_safety_range_change", "safety_range_change", "User changed the Safety Score Range In Bikeable Safety Score Tab", this.bikeableRange);
      this.processBikeableData()
    },
    handleBikeableRadiusSlider(){
      this.loading = true
      this.analyticsEvent("data_hub_safety_radius_change", "safety_radius_change", "User changed the Bikeable Radius Range", this.bikeableRadiusRange);
      this.processBikeableData()
    },
    handleCycleSlider() {
      this.loading = true
      this.analyticsEvent("data_hub_cycle_range_change", "cycle_range_change", "User changed the range of Cycle Risk Field In Cycling Risk Factor Tab", this.cycleRange);      
      this.processCycleData()
    },
    handleCycleRangeSlider() {
      this.loading = true
      this.analyticsEvent("data_hub_cycle_radius_change", "cycle_radius_change", "User changed the range of Cycle Risk Radius In Cycling Risk Factor Tab", this.cycleRadiusRange);      
      this.processCycleData()
    },
    convertToIntegers(minValue, maxValue) {
      var multiplier = 0
      if (minValue != 0){
        multiplier = Math.pow(10, String(minValue).split('.')[1].length);  
      } else {
        multiplier = Math.pow(10, String(maxValue).split('.')[1].length);
      }
      
      const minInt = Math.round(minValue * multiplier);
      const maxInt = Math.round(maxValue * multiplier);
      return { minValue: minInt, maxValue: maxInt, multiplier: multiplier };
    },
    formatValue(value) {
      return (value / this.multiplier);
    }
  }
}